<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ref, onMounted } from 'vue'
import { authService } from 'src/services/auth-service'
import type { UserProfile } from 'src/stores/auth-store-types'

// Setup Vue Router for navigation after login
const router = useRouter()

const usernameInput = ref('')
const availableProfiles = ref<UserProfile[]>([])

onMounted(async () => {
  if (typeof window !== 'undefined') {
    if (window) {
      if (typeof window.document !== 'undefined') {
        window.document.title = 'Play Tracker'
      }
    }
  } // if (typeof window !== 'undefined') {
  await authService.init()
  // 1. Get all profiles (to show in a dropdown or autocomplete)
  availableProfiles.value = await authService.getLocalProfiles()

  // 2. Prepopulate the input with the last person who logged in
  const lastUser = await authService.getLastActiveUsername()
  if (lastUser) {
    usernameInput.value = lastUser
  }
})
const handleLogin = async () => {
  // Prevent empty submissions
  if (!usernameInput.value.trim()) return

  const result = await authService.login(usernameInput.value)
  if (result.status === 'success') {
    await router.push({ name: 'GameSelection' })
  }
}
</script>
<template>
  <div class="row justify-center q-mt-xl">
    <q-card class="i-card" flat bordered>
      <q-card-section class="q-pa-md">
        <div class="text-h6 q-mb-md">Log in to Play Tracker</div>
        <q-separator />

        <q-input
          class="q-mt-lg"
          outlined
          v-model="usernameInput"
          label="User Name"
          @keyup.enter="handleLogin"
        ></q-input>
      </q-card-section>

      <q-card-actions align="left">
        <q-btn push color="primary" label="Login" @click="handleLogin"></q-btn>
      </q-card-actions>
    </q-card>
  </div>
</template>
<style lang="sass" scoped>
.i-card
  width: 100%
  max-width: 600px
</style>
